import React from 'react';
import { Navigation, Footer, CopyrightLabel, About, SocialMedia, PublishBanner, SiteMap } from '@fishrmn/fishrmn-components';
import Link from 'gatsby-link';
import 'semantic-ui-less/semantic.less';
import '../overrides/overrides.css';

export default class Layout extends React.PureComponent {
  render() {
    return (
      <div>
        <PublishBanner
          business={{ id: 46, type: 'restaurant', name: "Rossi's Pizza Owego" }}
          defaultDomain={ 'rossispizzaowego' }
          defaultShowBanner={false}
        />
        <Navigation
           position={ "top" }
           logo={ "https://fisherman-static.s3.amazonaws.com/public/rossispizzaowego/Rossis_Pizza.jpg" }
           primaryContentCentered={ false }
           evenSpacing={ true }
           bordered={ false }
           fixed={ false }
           backgroundColor={ "primary" }
           header={ "Rossi's Pizza Owego" }
           logoPosition={ "middle" }
           links={ [{"pageTitle":"Home","slug":"/","internal":true},{"pageTitle":"Locations","slug":"/locations/","internal":true},{"pageTitle":"About","slug":"/about/","internal":true},{"pageTitle":"Menu","slug":"/menu/","internal":true},{"pageTitle":"Frozen Pizza","slug":"/frozenpizza/","internal":true},{"pageTitle":"Order Now","slug":"https://www.toasttab.com/rossispizzaowego/v2/online-order#!/","internal": false, "emphasis": true }] }
           linksAs={ "h3" }
           linkComponent={ Link }
        />
        <div className="page-container">{this.props.children}</div>
        <Footer
           verticalAlign={ "middle" }
           horizontalAlign={ "center" }
           backgroundColor={ "primary" }
           columns={[
             <CopyrightLabel
                company={ "Rossi's Pizza Owego" }
                phrase={ "All Rights Reserved" }
             />,
             <SiteMap
                 links={ [{"pageTitle":"Home","slug":"/","internal":true},{"pageTitle":"Locations","slug":"/locations/","internal":true},{"pageTitle":"About","slug":"/about/","internal":true},{"pageTitle":"Menu","slug":"/menu/","internal":true},{"pageTitle":"Frozen Pizza","slug":"/frozenpizza/","internal":true},{"pageTitle":"Order Now","slug":"https://www.toasttab.com/rossispizzaowego/v2/online-order#!/","internal": false, "emphasis": true }] }
                 horizontal={false}
                 bulleted={false}
                 internalLinkComponent={Link}
             />,
             <SocialMedia
                buttonType={ "circle" }
                centerHeader={ true }
                colors={ "brand" }
                groupButtons={ false }
                groupVertically={ false }
                header={ "" }
                inverted={ false }
                labelPosition={ "right" }
                showLabels={ false }
                socialMediaValues={ [{"type":"yelp","link":"https://www.yelp.com/biz/rossis-pizza-owego-2","label":null},{"type":"facebook","link":"https://www.facebook.com/Rossis-Pizza-Endicott-111392605561637/","label":null}] }
             />,
           ]}
        />
      </div>
    );
  }
}